export default __webpack_public_path__ + "4163a98ec1a06b374da33ba7cb4efdcc.svg";